import { useEffect } from "react";

export default function useDisableInspect(enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const disableInspect = (e) => {
      // F12
      if (e.key === "F12") {
        e.preventDefault();
        return;
      }

      // Ctrl + Shift + I / J / C
    //   if (
    //     (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) ||
    //     (e.metaKey && e.altKey && ["I", "J", "C"].includes(e.key))
    //   ) {
    //     e.preventDefault();
    //     return;
    //   }

      // Ctrl + U
      if (e.ctrlKey && e.key.toLowerCase() === "u") {
        e.preventDefault();
      }
    };

    const disableRightClick = (e) => e.preventDefault();

    document.addEventListener("keydown", disableInspect);
    document.addEventListener("contextmenu", disableRightClick);

    return () => {
      document.removeEventListener("keydown", disableInspect);
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, [enabled]);
}